import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
declare var calendarJs: any;
declare var options: any;
@Component({
  selector: 'app-self-roaster',
  templateUrl: './self-roaster.component.html',
  styleUrls: ['./self-roaster.component.css']
})
export class SelfRoasterComponent implements OnInit {
  calendarInstance1:any;
  userData: any;
  clientId: any;
  clientName: any;
  backendEvents: any;
  isEventCreated: boolean= false;
  constructor(private commonService:CommonService) { }
  ngOnInit() {


    let userDataObj = localStorage.getItem('userData');
    if (userDataObj) {
      try {
        this.userData = JSON.parse(userDataObj);
        if(this.userData.attributes.role === 'clients'){
          this.clientId=this.userData.id;
          this.clientName=this.userData.email;
        }
      } catch (error) {

      }
    }
    this.calendarInstance1 = new calendarJs("calendar1", {
      exportEventsEnabled: true, 
      manualEditingEnabled: true, 
      onEventUpdated: (event: any) => {
        console.log('onEvonEventUpdated', event);
        if( this.isEventCreated){
        this.createRoaster(event.created,event.from,event.to,event.title);
        this.isEventCreated=false;
        }
        else{

        }
        
      },
      onEventAdded: (event: any) => {
        this.isEventCreated=true;
        console.log('onEventAdded', event);
    
      },
      onEventsAddedFromJSON: (event: any) => {
        console.log('onEventsAddedFromJSON', event);
    
      },
      onEventsSet: (event: any) => {
        console.log('onEventsSet', event);
 
      },
      onEventonEventsSetFromJSONsSet: (event: any) => {
        console.log('onEventonEventsSetFromJSONsSet', event);
    
      },

    });
    const currentDate = new Date();
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const fromDateISO = firstDayOfMonth.toISOString();
    const toDateISO = lastDayOfMonth.toISOString();
    this.commonService.getRequestWithToken(`emproster/search/Suzuki123?empId=${this.clientId}&fromdate=${fromDateISO}&todate=${toDateISO}`,[]).then(
      (resp:any)=>{
       console.log("roaster data",resp)
       this.backendEvents=resp.data;
       const formattedEvents = this.backendEvents.map(record => ({
        // id:record.id,
        title: record.remarks,
        from: new Date(record.loginTime),
        to: new Date(record.logoutTime),
        created: new Date(record.date),
    }));
    this.calendarInstance1.addEvents(formattedEvents);
      },(err)=>{

      })
   document.title += " v" + this.calendarInstance1.getVersion();
  }

createRoaster(createDate,loginTime,logoutTime,remarks){
  const requestBody={
    empid:this.clientId,
    date: createDate,
    clientid: this.clientName,
    loginTime: loginTime,
    logoutTime: logoutTime,
    status: "open",
    taskId:0,
    tripId: 0,
    remarks:remarks
  }
  this.commonService.postRequestWithToken('emproster',requestBody).then(
    (resp)=>{
      Swal.fire({
        icon: 'success',
        toast:true,
        title: 'Roaster created successfully',
        showConfirmButton: false,
        timer: 1500,
      });

   console.log(resp)
    },
    (err)=>{

    })
}
updateRoaster(id,createDate,loginTime,logoutTime,remarks){
  const requestBody={
    empid:this.clientId,
    date: createDate,
    clientid: this.clientName,
    loginTime: loginTime,
    logoutTime: logoutTime,
    status: "open",
    taskId:0,
    tripId: 0,
    remarks:remarks
  }
  this.commonService.putRequest(`emproster/id`,requestBody).then(
    (resp)=>{
      Swal.fire({
        icon: 'success',
        toaster:true,
        title: 'Roaster updated successfully',
        showConfirmButton: false,
        timer: 1500,
      });
    },
    (err)=>{

    }) 
}
}

interface Event {
  id: string;
  from: Date;
  to: Date;
  repeatEnds: Date;
  // Add other properties as needed
}

interface Options {
  onEventUpdated?: (event: Event) => void;
}
